import { gql } from '@apollo/client';

const EMAIL_CONFIRM_MUTATION = gql`
  mutation confirmUserEmail($token: String!) {
    confirmUserEmail(input: { token: $token }) {
      result {
        result
        extras
      }
    }
  }
`;

export default EMAIL_CONFIRM_MUTATION;
